export const ADMIN_ROLES = {
  SA: "Super Admin",
  AM: "Area Manager",
  BM: "Branch Manager",
  EO: "Experience Officer",
  LL: "Land Lord",
};
